var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-dialog', {
    attrs: {
      "title": "访客申请",
      "visible": _vm.showDialog
    },
    on: {
      "update:visible": function($event) {
        _vm.showDialog = $event
      }
    }
  }, [_c('el-row', [_c('el-col', {
    attrs: {
      "span": 12
    }
  }, [_c('el-card', {
    staticClass: "box-card"
  }, [(_vm.initData) ? _c('el-form', {
    attrs: {
      "label-width": "120px"
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "应聘者姓名"
    }
  }, [_vm._v(_vm._s(_vm.initData.resumeForm && _vm.initData.resumeForm.name))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "手机"
    }
  }, [_vm._v(_vm._s(_vm.initData.resumeForm && _vm.initData.resumeForm.mobilePhone || '-'))]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "应聘职位"
    }
  }, [_vm._v(_vm._s(_vm.initData.positionForm && _vm.initData.positionForm.name))])], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 12
    }
  }, [(_vm.baseData) ? _c('el-form', {
    attrs: {
      "model": _vm.form,
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "选择会议室",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-select', {
    attrs: {
      "placeholder": "请输入关键词"
    },
    model: {
      value: (_vm.form.areaid),
      callback: function($$v) {
        _vm.$set(_vm.form, "areaid", $$v)
      },
      expression: "form.areaid"
    }
  }, _vm._l((_vm.baseData.MEETING_AREA_NAME), function(item) {
    return _c('el-option', {
      key: item.value,
      attrs: {
        "label": item.text,
        "value": item.value
      }
    })
  }), 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "面试地点",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-input', {
    attrs: {
      "placeholder": "请输入内容"
    },
    model: {
      value: (_vm.form.interviewPlace),
      callback: function($$v) {
        _vm.$set(_vm.form, "interviewPlace", $$v)
      },
      expression: "form.interviewPlace"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "面试时间",
      "label-width": _vm.formLabelWidth
    }
  }, [_c('el-date-picker', {
    attrs: {
      "type": "datetime",
      "format": "yyyy-MM-dd HH:mm",
      "placeholder": "选择日期"
    },
    model: {
      value: (_vm.form.interviewDate),
      callback: function($$v) {
        _vm.$set(_vm.form, "interviewDate", $$v)
      },
      expression: "form.interviewDate"
    }
  })], 1)], 1) : _vm._e()], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    on: {
      "click": function($event) {
        _vm.showDialog = false
      }
    }
  }, [_vm._v("取 消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.submit
    }
  }, [_vm._v("确 定")])], 1)], 1)
}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-02358f8a"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/operation/vistorFlowDialog.vue
// module id = null
// module chunks = 